import { Injectable } from '@angular/core';

const TOKEN = 'refresh';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor() {}

  clean(): void {
    window.sessionStorage.clear();
  }

  saveToken(token: any): void {
    window.sessionStorage.removeItem(TOKEN);
    window.sessionStorage.setItem(TOKEN, token);
  }

  public getToken(): any {
    const token = window.sessionStorage.getItem(TOKEN);
    if (token) {
      return token;
    }

    return null;
  }

}